import templateUrl from "./assign-member-to-commander.html";
import "./assign-member-to-commander.scss";

export const assignMemberToCommanderComponent = {
  bindings: {
    commandersData: "<",
  },
  templateUrl,
  controller: class AssignMemberToCommanderComponent {
    constructor(
      $state,
      toastr,
      UserService,
      CommandCounsellorsService,
      AssignMemberToCommanderService
    ) {
      "ngInject";
      this.$state = $state;
      this.toastr = toastr;
      this.UserService = UserService;
      this.CommandCounsellorsService = CommandCounsellorsService;
      this.AssignMemberToCommanderService = AssignMemberToCommanderService;
    }
    $onInit() {
      this.membersData = {};
      this.membersList = [];
      this.disableButtons = false;
      this.currentMembersPage = 1;
      this.itemPerMemberPage = 10;
      this.memberSearchKeyword = "";
      this.showVeteransError = false;
      this.membersListIsOpen = true;
      this.selectedOption = "assign";
      this.membersListTitle = "Select Members (Can Select Multiple)";

      // commanders List data
      this.commandersTotalCount = this.commandersData.totalCount;
      this.commanderListIsOpen = true;
      this.careerCounselorId =
        this.commandersList && this.commandersList.length > 0
          ? this.commandersList[0].id
          : null;
      this.selectedCounselorId =
        this.commandersData.userList.length > 0
          ? this.commandersData.userList[0].careerCounselorId
          : null;
      this.commanderList = this.getCommandersList(this.commandersData.userList);
      this.selectedCommander =
        this.commandersList && this.commandersList.length > 0
          ? this.commandersList[0].id
          : null;

      // members list data
      if (!this.commandersData) {
        this.membersData = [];
      } else {
        this._getMembersData({
          excludeCounselor: this.selectedCounselorId,
        });
      }
      this.selectedMembers = [];
    }
    getCommandersList(list) {
      return [
        {
          type: "radio",
          isOpen: true,
          key: "Commander",
          showSearchBar: true,
          title: "Select Transition Manager you want to Assign to",
          defaultSelectedId: this.selectedCounselorId,
          data: list.map((value) => {
            return {
              id: value.careerCounselorId,
              name: value.name,
              isSelected: false,
              value: value.name,
              sendKey: value.careerCounselorId,
            };
          }),
        },
      ];
    }
    onCommandCounselorSearch(value) {
      const params = value !== "" ? { searchKeyword: value } : {};
      return this.CommandCounsellorsService.getCommandCounsellorsList(
        params
      ).then((data) => {
        this.commanderList = this.getCommandersList(data.userList);
      });
    }
    onMemberSearch(value) {
      this.memberSearchKeyword = value;
      this._getMembersData({
        excludeCounselor: this.selectedCounselorId,
        searchKeyword: value,
      });
    }
    _getMembersData(params, loadMore = false) {
      this.UserService.getUserList(params)
        .then((details) => {
          this.membersTotalCount = details.totalCount;
          if (loadMore) {
            this.membersList = [
              ...this.membersList,
              ...this._formatMembersList(details.userList),
            ];
          } else {
            this.membersList = this._formatMembersList(details.userList);
          }
          this.showMembersViewMore =
            details.totalCount > this.itemPerMemberPage &&
            details.userList.length >= this.itemPerMemberPage;
        })
        .catch((error) => {
          if (error.xhrStatus !== "abort") {
            this.toastr.error(error.data.errors.message);
          }
        });
    }
    onChangeMember(details) {
      if (details.Commander) {
        this.selectedCounselorId = details.Commander;
        this._getMembersData({
          excludeCounselor: this.selectedCounselorId,
        });
      }
      if (details.selectedParentItems) {
        this.selectedMembers = details.selectedParentItems;
        if (this.selectedMembers.length > 0) {
          this.showVeteransError = false;
        } else {
          this.showVeteransError = true;
        }
      }
    }
    loadMoreMembers() {
      this.currentMembersPage = this.currentMembersPage + 1;
      let params = {
        isMemberAssignedToCounselor: false,
        pageId: this.currentMembersPage,
        limit: this.itemPerMemberPage,
        excludeCounselor: this.selectedCounselorId,
      };
      if (this.selectedOption.toLowerCase() === "unassign") {
        params.isMemberAssignedToCounselor = true;
      }
      if (this.memberSearchKeyword) {
        params.searchKeyword = this.memberSearchKeyword;
      }
      this._getMembersData(params, true);
    }
    onSelectedOptionChange() {
      this.currentMembersPage = 1;
      let params = {
        isMemberAssignedToCounselor: false,
      };
      if (this.selectedOption.toLowerCase() === "unassign") {
        params.isMemberAssignedToCounselor = true;
      } else {
        params.excludeCounselor = this.selectedCounselorId;
      }

      this.UserService.getUserList(params)
        .then((details) => {
          this.showMembersViewMore =
            details.totalCount > this.itemPerMemberPage &&
            details.userList.length >= this.itemPerMemberPage;
          this.membersList = this._formatMembersList(details.userList);
        })
        .catch((errmsg) => {
          this.toastr.error(errmsg);
        });
    }
    onSubmit() {
      if (this.selectedMembers.length > 0) {
        if (this.selectedOption.toLowerCase() === "assign") {
          this.disableButtons = true;
          this.AssignMemberToCommanderService.assignVeteransToCommander({
            careerCounselorId: this.selectedCounselorId,
            veterans: this.selectedMembers,
          })
            .then((_) => {
              this.toastr.success(
                "Members are assigned to a transition manager successfully"
              );
              this.$state.go("home");
            })
            .catch((errmsg) => {
              this.toastr.error(errmsg);
              this.disableButtons = false;
            });
        } else {
          this.disableButtons = true;
          this.AssignMemberToCommanderService.unassignVeteransToCommander({
            veterans: this.selectedMembers,
          })
            .then((_) => {
              this.toastr.success(
                "Members are unassigned from a transition manager successfully"
              );
              this.$state.go("home");
            })
            .catch((errmsg) => {
              this.toastr.error(errmsg);
              this.disableButtons = false;
            });
        }
      } else {
        this.showVeteransError = true;
      }
    }
    _formatMembersList(list) {
      return list.map((value) => {
        let subName = "";
        if (value.careerCounselor) {
          subName = `Member already assigned to counselor ${value.careerCounselor}`;
        }
        return {
          id: value.accountId,
          name: value.name,
          isSelected: false,
          value: value.name,
          sendKey: value.name,
          subName,
        };
      });
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/assign-member-to-commander/assign-member-to-commander.component.js